import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indianapolis',
  templateUrl: './indianapolis.component.html',
  styleUrls: ['./indianapolis.component.css']
})
export class IndianapolisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
